// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamic-title[data-v-4c1f8293] {\n  font-size: 1rem;\n  margin-bottom: 15px;\n}\n.timeline-wrapper[data-v-4c1f8293] {\n  margin-top: 24px;\n}", ""]);
// Exports
module.exports = exports;
